import useUser from '@hooks/user/use-user';
import { useTranslation } from 'next-i18next';
import useGetShippingAddresses from '@hooks/orders-sales/use-get-shipping-address';
import { useEffect, useState } from 'react';
import { ShippingAddress } from '@interfaces/api/responses/user-shipping-address';
import popinStyles from '../../popin.module.scss';
import AddressModalWrapper from '../address-form-web-component/address-wrapper';
import AddressModal, { AdserType } from '../address-form-web-component/address-modal';

const SHIPPING_FROM_FLAG_NAME = 'shipping';

interface UpdateShippingAddressModalProps {
  isOpen?: boolean;
  onClose: () => void;
}

const UpdateShippingAddressModal = ({ isOpen = true, onClose }: UpdateShippingAddressModalProps) => {
  const { t } = useTranslation(['orders-sales', 'default-layout']);

  const { user } = useUser();

  const { data: addresses, isLoading: addressLoading } = useGetShippingAddresses();

  const [shippingFromAddress, setShippingFromAddress] = useState<ShippingAddress>();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const title = t(`MY_ACCOUNT.ORDERS_SALES.POPUP.GET_SHIPPING_LABEL.SHIPPING`);

  useEffect(() => {
    if (!addresses || !addresses.length) {
      return;
    }
    const addressItem = addresses.find((a) => !!a.address.flagList?.some((f) => f.name === SHIPPING_FROM_FLAG_NAME));

    // If the user has multiple addresses, on the web open “My account”
    if (!addressItem && addresses.length > 1) {
      setIsRedirecting(true);
      window.location.href = '/my-account.shtml';
    } else {
      setShippingFromAddress(addressItem?.address);
    }
  }, [addresses]);

  if (isRedirecting) {
    return null;
  }

  if (addressLoading) {
    return (
      <AddressModalWrapper
        title={title}
        open
        onClose={onClose}
      >
        {addressLoading && <div className={popinStyles.ordersSales__popin__loading} />}
      </AddressModalWrapper>
    );
  }

  if (!shippingFromAddress) {
    return (
      <AddressModalWrapper
        title={title}
        open
        onClose={onClose}
      >
        <p>{t('MY_ACCOUNT.ORDERS_SALES.POPUP.UPDATE_ADDRESS.ERROR_ADDRESS_LOAD')}</p>
      </AddressModalWrapper>
    );
  }

  const adserProps: AdserType = {
    displayScreen: 'inPage',
    nextStepDisplay: 'inPage',
    screen: 'default',
    context: 'account',
    editAddress: {
      clientId: user.id,
      country: shippingFromAddress.country.iso2,
      id: shippingFromAddress.addressId.toString(),
      onSuccessCallback: onClose,
    },
  };

  return (
    <AddressModal
      title={title}
      adserProps={adserProps}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};

export default UpdateShippingAddressModal;
